import { API_AUTH } from "../common";

const DanhSachTatToanApi = {
  getDataTable: ({
    SearchText,
    DateFrom,
    DateTo,
    sUsername,
    TypeChoVay,
    Operator,
    SoTien,
    pageIndex,
    pageSize,
  }) =>
    API_AUTH.get(
      `DanhSachTatToan/SelectByPage?SearchText=${SearchText}&DateFrom=${DateFrom}&DateTo=${DateTo}&sUsername=${sUsername}&TypeChoVay=${TypeChoVay}&Operator=${Operator}&SoTien=${SoTien}&PageIndex=${pageIndex}&PageSize=${pageSize}`,
      {}
    ),
  ChangeIsReaded: ({ ThuChiID, IsReaded }) =>
    API_AUTH.post(
      `DanhSachTatToan/changeIsReaded?ThuChiID=${ThuChiID}&IsReaded=${IsReaded}`,
      {}
    ),
  phanQuyen: () => API_AUTH.get(`bao-cao/phan-quyen-danh-sach-tat-toan`, {}),
  DeleteTatToan: ({ danhSach }) =>
    API_AUTH.post(`bao-cao/xoa-tat-toan?danhSach=${danhSach}`, {}),
  getDataInDanhSach: ({
    SearchText,
    DateFrom,
    DateTo,
    sUsername,
    TypeChoVay,
    Operator,
    SoTien,
  }) =>
    API_AUTH.get(
      `DanhSachTatToan/InDanhSachTatToan?SearchText=${SearchText}&DateFrom=${DateFrom}&DateTo=${DateTo}&sUsername=${sUsername}&TypeChoVay=${TypeChoVay}&Operator=${Operator}&SoTien=${SoTien}`,
      {}
    ),
};
export default DanhSachTatToanApi;
